/* Foreva Jewels email popup (sections/fj-email-popup.liquid).
 * Opens after a delay unless the visitor signed up before or closed it recently, and waits while the
 * event popup is open. Signups post to Shopify's customer form (newsletter); if Shopify asks for a
 * captcha the form is submitted normally and the code is shown when the visitor comes back. */
(() => {
  const dialog = document.getElementById('FjPop');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const KEY_DONE = 'fj_pop_done';
  const KEY_CLOSED = 'fj_pop_closed_at';
  const KEY_PENDING = 'fj_pop_pending';
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* storage blocked */ } },
    del(k) { try { localStorage.removeItem(k); } catch (e) { /* storage blocked */ } },
  };

  const delay = (Number(dialog.dataset.delay) || 10) * 1000;
  const snoozeMs = (Number(dialog.dataset.snooze) || 14) * 86400000;
  const form = dialog.querySelector('#FjPopForm');
  const email = dialog.querySelector('#FjPopEmail');
  const error = dialog.querySelector('.fj-pop__error');
  const tab = document.querySelector('[data-fj-pop-open]');

  // Photo slideshow: only the first photo loads with the popup; each next one is fetched one slide ahead.
  const slideBox = dialog.querySelector('[data-fj-pop-slides]');
  const slides = slideBox ? [...slideBox.querySelectorAll('.fj-pop__img')] : [];
  const bars = slideBox ? [...slideBox.querySelectorAll('.fj-pop__bar')] : [];
  const slideMs = (Number(slideBox?.dataset.interval) || 4) * 1000;
  let slideIndex = 0;
  let slideTimer = null;
  const load = (img) => {
    if (img && img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; }
  };
  const showSlide = (n) => {
    slides.forEach((img, i) => img.classList.toggle('is-on', i === n));
    bars.forEach((bar, i) => {
      bar.classList.toggle('is-done', i < n);
      bar.classList.remove('is-on');
      if (i === n) { void bar.offsetWidth; bar.classList.add('is-on'); }
    });
    load(slides[(n + 1) % slides.length]);
  };
  const startSlides = () => {
    if (slides.length < 2 || slideTimer) return;
    showSlide(slideIndex);
    slideTimer = setInterval(() => {
      const next = (slideIndex + 1) % slides.length;
      const img = slides[next];
      load(img);
      if (img.complete && img.naturalWidth) { slideIndex = next; showSlide(slideIndex); }
    }, slideMs);
  };
  const stopSlides = () => {
    if (dialog.open) return; // a late "close" event after a quick reopen must not stop the new run
    clearInterval(slideTimer);
    slideTimer = null;
  };
  dialog.addEventListener('close', stopSlides);

  const step = (name) => {
    dialog.querySelectorAll('[data-fj-pop-step]').forEach((el) => { el.hidden = el.dataset.fjPopStep !== name; });
  };
  const otherPopupOpen = () => {
    const o = document.querySelector('.fje-pop-overlay');
    return !!(o && !o.hidden && o.offsetParent !== null);
  };
  const open = () => {
    if (dialog.open) return;
    if (tab) tab.hidden = true;
    dialog.showModal();
    startSlides();
    if (window.dataLayer) window.dataLayer.push({ event: 'fj_popup_view' });
  };
  const openWhenFree = () => {
    if (!otherPopupOpen()) return open();
    const t = setInterval(() => { if (!otherPopupOpen()) { clearInterval(t); setTimeout(open, 1500); } }, 1000);
  };
  const close = () => {
    dialog.close();
    if (store.get(KEY_DONE)) return;
    store.set(KEY_CLOSED, String(Date.now()));
    if (tab) tab.hidden = false;
  };
  const showDone = () => {
    store.set(KEY_DONE, '1');
    store.del(KEY_PENDING);
    step('done');
    if (tab) tab.remove();
    dialog.querySelector('.fj-pop__title--done')?.focus();
    if (window.dataLayer) window.dataLayer.push({ event: 'fj_popup_signup' });
  };

  dialog.addEventListener('click', (e) => {
    if (e.target.closest('[data-fj-pop-close]') || e.target === dialog) close();
  });
  dialog.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
  tab?.addEventListener('click', () => { step(store.get(KEY_DONE) ? 'done' : 'form'); open(); });

  dialog.querySelector('[data-fj-pop-copy]')?.addEventListener('click', async (e) => {
    const code = dialog.querySelector('[data-fj-pop-code]').textContent.trim();
    try { await navigator.clipboard.writeText(code); e.target.textContent = 'Copied'; } catch (err) {
      const r = document.createRange(); r.selectNodeContents(dialog.querySelector('[data-fj-pop-code]'));
      const sel = getSelection(); sel.removeAllRanges(); sel.addRange(r);
    }
  });

  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const value = email.value.trim();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
    error.hidden = valid;
    email.setAttribute('aria-invalid', valid ? 'false' : 'true');
    if (!valid) { email.focus(); return; }

    form.classList.add('is-busy');
    try {
      const res = await fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
      if (res.url.includes('/challenge')) throw new Error('captcha');
      if (!res.ok) throw new Error('http ' + res.status);
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: value });
      showDone();
    } catch (err) {
      // Let Shopify handle it (captcha or network trouble); show the code when the visitor returns.
      store.set(KEY_PENDING, '1');
      HTMLFormElement.prototype.submit.call(form);
    } finally {
      form.classList.remove('is-busy');
    }
  });

  // Back from a normal (non-AJAX) submit
  const params = new URLSearchParams(location.search);
  if (store.get(KEY_PENDING) && params.get('customer_posted') === 'true') {
    showDone();
    return openWhenFree();
  }

  if (store.get(KEY_DONE)) return;
  const closedAt = Number(store.get(KEY_CLOSED) || 0);
  if (closedAt && Date.now() - closedAt < snoozeMs) {
    if (tab) tab.hidden = false;
    return;
  }
  setTimeout(openWhenFree, delay);
})();
